export default {"src":"/_next/static/media/0x10b2aa5d77aa6484886d8e244f0686ab319a270d.293a6dbe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};